module.exports = __webpack_public_path__ + "assets/img/operaterule_step2.1a0c02ad.png";